import { useTelemetryViewEvent } from 'common/hooks';
import {
  DeliveryTypeValueType,
  deliveryTypeModalDataConfirm,
  deliveryTypeModalView,
  restaurantDetailsInteractionClickSwitchDeliveryType,
  restaurantDetailsView,
  restaurantDetailsInteractionSaveOpeningTimes,
  restaurantDetailsInteractionSaveSpecialHours,
} from 'core/telemetry/avo/Avo';

export const useTelemetryRestaurantDetailsViewTracking = () => {
  useTelemetryViewEvent('restaurantDetailsView', {}, durationMs => restaurantDetailsView({ durationMs }));
};

export const telemetryRestaurantDetailsInteractionClickSwitchDeliveryType = () => {
  restaurantDetailsInteractionClickSwitchDeliveryType({ viewType: 'venue' });
};

export const useTelemetryDeliveryTypeModalViewTracking = (source: 'restaurant_details' | 'live_purchases') => {
  useTelemetryViewEvent(`deliveryTypeModalView/${source}`, { source }, (durationMs, context) =>
    deliveryTypeModalView({ durationMs, ...context }),
  );
};

export const telemetryDeliveryTypeModalDataConfirm = (deliveryType: DeliveryTypeValueType) => {
  deliveryTypeModalDataConfirm({
    viewType: 'venue',
    deliveryType,
  });
};

export const telemetryRestaurantDetailsInteractionSaveOpeningTimes = () => {
  restaurantDetailsInteractionSaveOpeningTimes();
};

export const telemetryRestaurantDetailsInteractionSaveSpecialHour = () => {
  restaurantDetailsInteractionSaveSpecialHours();
};
